import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DisplayPayments from '../Payments/DisplayPayments';
import { paymentStatusEnum } from '../../../lib/enum';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const PaymentsWrapper = (props) => {
  const classes = useStyle();
  const [value, setValue] = useState(0);


  const getPliciesStatus = (tabValue) => {
    switch (tabValue) {
      case 0:
        return paymentStatusEnum.Un_Confirmed
      case 1:
        return paymentStatusEnum.Rejected
      default:
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    const payload = {
      "status": getPliciesStatus(newValue)
    }
    props.getPolicies(payload)
  };

  return (
    <>
      <section className={classes.claimswrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="payments dashboards" variant="scrollable"
                scrollButtons="auto" className={classes.tabs}>
                <Tab label="Awaiting approval" {...a11yProps(0)} />
                <Tab label="Incomplete Payments" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0} >
              <DisplayPayments payments={props.payments} loader={props.loader}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
            <DisplayPayments payments={props.payments} loader={props.loader}/>
            </TabPanel>
         

          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default PaymentsWrapper